"use strict";

var curry2 = require("./curry2.js");

var go = require("./go.js");

var select = require("./sel.js");

module.exports = curry2(function selSatisfies(f, selector, obj) {
  return go(obj, select(selector), f, Boolean);
});